import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { Bg, Chip, DISPLAY, INK, LIME, popIn, pulse, UI } from "./theme";

/* ════════════════════════════════════════════════════════════════════════
   SCENE 5 — CALL TO ACTION (frame 690-900 / 23-30s, 210 frame)
   Latar lime. Teks raksasa berdenyut, tombol meledak masuk, panah memantul.
   ════════════════════════════════════════════════════════════════════════ */

export const Scene5CTA: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Headline: pop masuk lalu berdenyut terus-menerus.
  const headIn = spring({ frame, fps, config: { damping: 9, stiffness: 260, mass: 0.9 } });
  const headScale = interpolate(headIn, [0, 1], [0.4, 1]) * pulse(frame, 42, 0.04);
  const headRot = Math.sin(frame / 42) * 1.1;

  const btn = popIn(frame, fps, 42, { damping: 8, stiffness: 300, mass: 1 });
  const btnScale = interpolate(btn.scale, [0, 1], [0, 1]);
  const btnPulse = 1 + Math.sin((frame / 34) * Math.PI * 2) * 0.03;

  const arrow = popIn(frame, fps, 96, { damping: 10, stiffness: 320, mass: 0.9 });
  const bounce = Math.abs(Math.sin((frame - 96) / 12)) * 28;
  const link = popIn(frame, fps, 118, { damping: 11, stiffness: 300, mass: 0.9 });

  return (
    <AbsoluteFill style={{ fontFamily: UI, color: INK }}>
      <Bg color={LIME} pattern="stripes" patternOpacity={0.13}>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-12 px-[40px]">
          {/* ── Chip atas ── */}
          <Chip className="bg-black text-[30px] text-[#B8FF2F]">PANGKASIN · SISTEM KASIR BARBERSHOP</Chip>

          {/* ── Headline raksasa (berdenyut) ── */}
          <div style={{ transform: `scale(${headScale}) rotate(${headRot}deg)` }}>
            <div className="border-[6px] border-black bg-white px-8 py-7 text-center shadow-[14px_14px_0px_0px_rgba(0,0,0,1)]">
              <div className="text-[132px] uppercase leading-[0.86] text-black" style={{ fontFamily: DISPLAY }}>
                FREE TRIAL
              </div>
              <div
                className="mt-3 border-4 border-black bg-black px-4 py-1 text-[112px] uppercase leading-[0.9] text-[#B8FF2F]"
                style={{ fontFamily: DISPLAY }}
              >
                1 BULAN!
              </div>
              <div className="mt-5 text-[36px] uppercase leading-none text-black" style={{ fontFamily: DISPLAY }}>
                GRATIS PENUH · TANPA KARTU KREDIT
              </div>
            </div>
          </div>

          {/* ── Tombol CTA (pop meledak) ── */}
          <div style={{ transform: `scale(${btnScale * btnPulse})` }}>
            <div className="relative">
              {/* cincin denyut di belakang tombol */}
              <div
                className="absolute inset-0 border-4 border-black"
                style={{
                  transform: `scale(${1 + Math.sin((frame / 30) * Math.PI * 2) * 0.06})`,
                  opacity: 0.35,
                }}
              />
              <div className="relative flex items-center gap-5 border-4 border-black bg-black px-9 py-7 shadow-[12px_12px_0px_0px_rgba(255,255,255,1)]">
                <div
                  className="whitespace-nowrap text-[52px] uppercase leading-none text-[#B8FF2F]"
                  style={{ fontFamily: DISPLAY }}
                >
                  COBA GRATIS SEKARANG
                </div>
                <div
                  className="border-4 border-[#B8FF2F] px-3 py-1 text-[36px] text-[#B8FF2F]"
                  style={{ fontFamily: DISPLAY }}
                >
                  →
                </div>
              </div>
            </div>
          </div>

          {/* ── Panah memantul + link ── */}
          <div className="flex flex-col items-center gap-5">
            <div style={{ transform: `translateY(${bounce}px)`, opacity: arrow.opacity }}>
              <div className="flex flex-col items-center">
                <div className="h-[110px] w-[28px] border-4 border-black bg-black" />
                <div
                  style={{
                    width: 0,
                    height: 0,
                    marginTop: -4,
                    borderLeft: "42px solid transparent",
                    borderRight: "42px solid transparent",
                    borderTop: `52px solid ${INK}`,
                  }}
                />
              </div>
            </div>

            <div style={{ opacity: link.opacity, transform: `scale(${link.scale})` }}>
              <div
                className="border-4 border-black bg-[#FFE14D] px-7 py-3 text-[38px] uppercase shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]"
                style={{ fontFamily: DISPLAY }}
              >
                KLIK LINK DI BAWAH
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="border-4 border-black bg-white px-5 py-2 text-[30px]" style={{ fontFamily: DISPLAY }}>
                barbershop.carroo.my.id
              </div>
              <div
                className="border-4 border-black bg-black px-5 py-2 text-[30px] text-white"
                style={{ fontFamily: DISPLAY }}
              >
                WA 0895-3970-7331
              </div>
            </div>
          </div>
        </div>
      </Bg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
